import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Components
import {
    Grid,
    Typography,
    Switch,
} from '@material-ui/core';

// css
import { withStyles } from '@material-ui/core';
const styles = theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    alignCenter: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    alignLeft: {
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center'
    },
    greyText: {
        color: 'rgba(0, 0, 0, 0.3)'
    }
});



class FormFieldNonRivendibile extends Component {
    constructor(props) {
        super(props);


        this.handleNonRivendibileChange = this.handleNonRivendibileChange.bind(this);
    }

    handleNonRivendibileChange(newValue) {
        const { handleChangeField, setAllActive, isReadOnly } = this.props;

        if (!isReadOnly) {
            if (newValue === true) {
                setAllActive(); //se non rivendibile metto tutti i moduli attivi
                handleChangeField('LicNonRivend', newValue);
            }
            else {
                handleChangeField('LicNonRivend', newValue);
            }
        }
    }


    render() {
        const { classes, non_rivendibile } = this.props;

        return (
            <Grid className={classes.alignCenter}
                container
                spacing={1}
            >
                <Grid item>
                    <Typography variant="body1" className={non_rivendibile === false ? classes.greyText : null}>Non Rivendibile</Typography>
                </Grid>
                <Grid item>
                    <Switch
                        checked={!non_rivendibile}
                        onChange={newValue => this.handleNonRivendibileChange(!newValue.target.checked)}
                        color="primary"
                        inputProps={{ 'aria-label': 'primary checkbox' }}
                    />
                </Grid>
                <Grid item>
                    <Typography variant="body1" className={non_rivendibile === true ? classes.greyText : null}>Rivendibile</Typography>
                </Grid>
            </Grid>
        );
    }
}

FormFieldNonRivendibile.propTypes = {
    handleChangeField: PropTypes.func.isRequired,
    setAllActive: PropTypes.func.isRequired,
    non_rivendibile: PropTypes.bool.isRequired,

    isReadOnly: PropTypes.bool.isRequired,
};

export default withStyles(styles)(FormFieldNonRivendibile);